import { render, staticRenderFns } from "./MainLoading.vue?vue&type=template&id=2bb6aec0&scoped=true&"
var script = {}
import style0 from "./MainLoading.vue?vue&type=style&index=0&id=2bb6aec0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb6aec0",
  null
  
)

export default component.exports